/*

First section controls the appearance of the slide down product bar / add to cart
section that appears when you scroll a certain distance down the product page.

 */
document.addEventListener('scroll', checkForProductBar);

const productBar = document.getElementById("product-bar");
let vertScrollPos = 0;

/* need to make the const below check the position of the add to cart button */
const productBarTrigger = 1300;

function checkForProductBar()
{

    vertScrollPos = window.scrollY;

    if(vertScrollPos > (productBarTrigger+50)) {

        const mainHeader = document.getElementById('sticky-header');
        const mainHeaderHeight = mainHeader.offsetHeight - 1;

        productBar.style.top = mainHeaderHeight + "px";
        productBar.classList.add('show');

    } else if (vertScrollPos < (productBarTrigger-50)) {
        productBar.classList.remove('show');
    } else {
        productBar.style.top = "0";
    }
}

/* ----------------------- end of product bar controller ------------------------------ */


/*

The left and right arrow for the product image thumbnails scroller

 */

const rightArrow = document.querySelector(".images .right-arrow");
const leftArrow = document.querySelector(".images .left-arrow");
const scrollWindow = document.querySelector('.images .scroll-window');

rightArrow.addEventListener('click', scrollWindowRight);
leftArrow.addEventListener('click', scrollWindowLeft);

function scrollWindowRight()
{
    const width = scrollWindow.offsetWidth;

    scrollWindow.scrollBy({
        top: 0,
        left: width,
        behavior: "smooth",
    });
}

function scrollWindowLeft()
{
    const width = scrollWindow.offsetWidth;

    scrollWindow.scrollBy({
        top: 0,
        left: -width,
        behavior: "smooth",
    });
}

/* ----------------------- end of product thumbnails scroller ------------------------------ */


/*

Open or close the product availability modal window

 */

const availability = document.getElementById('availability');
availability.addEventListener('click', toggleAvailabilityModal);

const availabilityOverlay = document.getElementById('availability-overlay');
const availabilityOverlayClose = document.getElementById('availability-close');


availabilityOverlay.addEventListener('click', ( e ) => {
    e.preventDefault();
    if ( e.target.closest('#availability-info') ) {
        /* Don't close, that's a click in our info box */
        return false;
    } else {
        /* Do close, that's a click on the overlay itself */
        toggleAvailabilityModal();
    }
});
availabilityOverlayClose.addEventListener('click', ( e ) => {
    e.preventDefault();
    toggleAvailabilityModal();
})


function toggleAvailabilityModal()
{
    /* toggleOverlay defined in the header.js file */
    toggleOverlay();
    toggleAvailability();
}


function toggleAvailability()
{
    availabilityOverlay.classList.toggle('show');
}

/* ----------------------- end of product availability modal ------------------------------ */


/*

Show the larger image when clicking on one of the thumbnails

 */

const thumbnails = document.querySelectorAll('.images .thumbnail');
const mainImage = document.getElementById('main-image');

thumbnails.forEach(function(current) {
    current.addEventListener('click', showImage);
})

function showImage(e)
{
    const imageSrc = e.target.getAttribute('src')
    const queryString = /[?].*/

    const newPath = imageSrc.replace(queryString, "");

    mainImage.setAttribute('src', newPath);

}

const imageOverlay = document.getElementById("image-overlay");
imageOverlay.addEventListener('click', toggleImageModal);

function toggleImageModal(e)
{

    const imageSrc = e.target.getAttribute('src');
    const overlayImage = document.getElementById('overlay-main-image');

    overlayImage.setAttribute('src', imageSrc);

    /* toggleOverlay defined in the header.js file */
    toggleOverlay();
    toggleImage();
}

function toggleImage()
{
    imageOverlay.classList.toggle('show');

    let delay = 100;
    imageOverlayThumbs.forEach(function(current){
        setTimeout(function(){current.classList.toggle('small')}, delay);
        delay += 50;
    })

}

mainImage.addEventListener('click', toggleImageModal);

/* now add event listeners for the thumbnails actually in the pop up window */

const imageOverlayThumbs = document.querySelectorAll(".image-overlay .image-overlay-thumbs .thumbnail");

imageOverlayThumbs.forEach(function(current) {
    current.addEventListener('click', updatePopupImage)
})

function updatePopupImage(e)
{
    const imageSrc = e.target.getAttribute('src');
    const overlayImage = document.getElementById('overlay-main-image');

    overlayImage.setAttribute('src', imageSrc);

    e.stopPropagation();
}

/* ----------------------- end of larger image viewer modal ------------------------------ */


/*

Show the video pop-up when clicking on one of the video previews

 */


const videoOverlay = document.getElementById("video-overlay");
videoOverlay.addEventListener('click', hideVideoModal);

const videoThumbnails = document.querySelectorAll('.images .video-thumbnail');
const videoPlayers = document.querySelectorAll(".video-overlay .video-viewer .video-player");

/* create the embedded YouTube controller objects */
const YTPlayers = [];

window.YT.ready(function() {
    videoPlayers.forEach(function(current) {
        let playerWindow = current.querySelector("iframe");

        if (playerWindow) {
            let frameId = "vid" + current.getAttribute('id');

            playerWindow.setAttribute('id', frameId);

            YTPlayers.push(getYTPlayer(frameId));

        }
    });
})


function getYTPlayer(id) {
    let player = new YT.Player(id);
    return player;
}

videoThumbnails.forEach(function(current) {
    current.addEventListener('click', showVideo);
})


function showVideo(e)
{

    adjustVideoSize();

    const videoID = e.currentTarget.dataset.media;

    videoPlayers.forEach(function(current) {

        const vID = current.getAttribute('id');

        if(vID == videoID) {
            current.classList.remove('hide');

        } else {
            current.classList.add('hide');
        }
    })

    /* toggleOverlay defined in the header.js file */
    toggleOverlay();
    toggleVideo();
}

/* We want the video to scale properly on window resize */

window.addEventListener('resize', adjustVideoSize);

function adjustVideoSize()
{
    let playerWidth = window.innerWidth > 1200 ? 1160 : window.innerWidth - 40;
    const maxHeight = window.innerHeight - 20;

    videoPlayers.forEach(function(current) {

        let playerHeight = Math.round(playerWidth / current.dataset.aspect);

        if(playerHeight > maxHeight) {
            playerHeight = maxHeight;

            playerWidth = Math.round(playerHeight * current.dataset.aspect);
        }

        let playerWindow = current.querySelector("iframe");

        if(playerWindow) {
            playerWindow.style.width = playerWidth + "px";
            playerWindow.style.height = playerHeight + "px";
        } else {
            let playerWindow = current.querySelector("video");
            playerWindow.setAttribute('width', playerWidth + "px");
        }

    })
}

function hideVideoModal(e)
{
    // prevent descendent elements from firing

    const target = e.target;

    if(target.getAttribute('id') == 'video-overlay' || target.classList.contains('video-player') || target.classList.contains('video-viewer')) {

        /* pause all videos first */

        videoPlayers.forEach(function(current) {

            if(!current.classList.contains('hide')) {

                let playerWindow = current.querySelector("iframe");

                if (playerWindow) {

                   for(const ytp of YTPlayers) {
                       ytp.pauseVideo();
                   }

                } else {
                    /* native video */
                    let playerWindow = current.querySelector("video");
                    playerWindow.pause();
                }
            }

        })

        /* toggleOverlay defined in the header.js file */
        toggleOverlay();
        toggleVideo();

    }
}



function toggleVideo()
{
    videoOverlay.classList.toggle('show');
}

/* ----------------------- end of video viewer modal ------------------------------ */

addEventListener("load", function() {
    const stars = document.getElementById('product-star-rating');
    stars.classList.add('visible');

    // const subMenu = document.getElementById('product-page-quick-links');
    // subMenu.classList.add('visible');
});
